import { Controller } from "@hotwired/stimulus"

// Syncs a per-resource quick-set <select> with its four permission pills.
export default class extends Controller {
  static targets = ["preset", "pill"]

  connect() { this.syncPreset() }

  applyPreset() {
    const preset = this.presetTarget.value
    if (preset === "custom") return
    const enabled = {
      full: ["read", "create", "update", "delete"],
      read: ["read"],
      none: []
    }[preset] || []
    this.pillTargets.forEach((pill) => {
      pill.checked = enabled.includes(pill.dataset.verb)
    })
  }

  // When a pill is toggled by hand, reflect the derived preset (or "custom").
  pillToggled() { this.syncPreset() }

  syncPreset() {
    const on = this.pillTargets.filter((p) => p.checked).map((p) => p.dataset.verb)
    const set = new Set(on)
    let preset = "custom"
    if (set.size === 0) preset = "none"
    else if (set.size === 1 && set.has("read")) preset = "read"
    else if (set.size === 4) preset = "full"
    this.presetTarget.value = preset
  }
}
